<div class="flex flex-col h-full w-full overflow-hidden">
  <!-- Content -->
  <div class="flex flex-col gap-3 flex-1 overflow-hidden">
    <!-- Stats Row -->
    <div #statsRow class="flex flex-row gap-3 w-full">
      <div [appSkeletonLoading]="loading" class="stat-box flex flex-col items-center justify-center flex-1 px-3 py-3 bg-gray-50 rounded-lg gap-1" tooltip="Gesamtgröße"
           tooltipDirection="top">
        <fa-icon [icon]="faArrowDownToBracket" class="text-base h-[16px] flex text-gray-900"></fa-icon>
        <div class="text-gray-900 text-sm font-medium">{{ formattedSize }}</div>
        @if (!compactStats) {
          <div class="text-gray-500 text-xs font-normal">Gesamtgröße</div>
        }
      </div>
      <div [appSkeletonLoading]="loading" class="stat-box flex flex-col items-center justify-center flex-1 px-3 py-3 bg-gray-50 rounded-lg gap-1" tooltip="Dateien"
           tooltipDirection="top">
        <fa-icon [icon]="faFile" class="text-base h-[16px] flex text-gray-900"></fa-icon>
        <div class="text-gray-900 text-sm font-medium">{{ totalFiles }}</div>
        @if (!compactStats) {
          <div class="text-gray-500 text-xs font-normal">Dateien</div>
        }
      </div>
      <div [appSkeletonLoading]="loading" class="stat-box flex flex-col items-center justify-center flex-1 px-3 py-3 bg-gray-50 rounded-lg gap-1" tooltip="Ordner"
           tooltipDirection="top">
        <fa-icon [icon]="faFolderOpen" class="text-base h-[16px] flex text-gray-900"></fa-icon>
        <div class="text-gray-900 text-sm font-medium">{{ totalFolders }}</div>
        @if (!compactStats) {
          <div class="text-gray-500 text-xs font-normal">Ordner</div>
        }
      </div>
    </div>

    <!-- File Types Section -->
    <div class="flex flex-col gap-2">
      <span class="text-gray-900 text-sm font-medium">Dateitypen (Nach Größe)</span>
      <!-- Stacked Bar -->
      <div [appSkeletonLoading]="loading" class="flex flex-row w-full h-[26px] rounded-lg overflow-hidden gap-px">
        @for (type of allFileTypesForBar; track type.label) {
          <div class="h-full" [style.background-color]="type.bgColorClass" [style.width]="getBarWidth(type)"></div>
        }
      </div>
    </div>

    <!-- Legend -->
    @if (hasFiles) {
      <div class="flex flex-col gap-3 flex-1 overflow-y-auto">
        @for (type of visibleFileTypeDisplays; track type.label) {
          <div class="flex flex-row items-center gap-3">
            <div class="flex flex-row items-center gap-3 flex-1 min-w-0">
              <div class="w-3 h-3 rounded-sm shrink-0" [style.background-color]="type.bgColorClass"></div>
              <span class="text-gray-900 text-sm font-normal truncate">{{ type.label }}</span>
            </div>
            <div class="flex flex-row items-center gap-2 justify-end shrink-0">
              <span class="text-gray-900 text-sm font-normal">{{ type.count }} Dateien</span>
              <span class="text-gray-900 text-sm font-normal">{{ formatFileSize(type.size) }}</span>
            </div>
          </div>
        }
      </div>
    } @else {
      <div [appSkeletonLoading]="loading" class="flex flex-1 rounded-lg">
        <app-empty-state [icon]="faFolderOpen" message="Es wurden noch keine Dateien hochgeladen"></app-empty-state>
      </div>
    }
  </div>

</div>
